import type { RouteRecordRaw } from 'vue-router'

/**
 * 基础路由
 */
const routes : RouteRecordRaw[] = [
  // 简化布局路由组（无侧边栏）
  {
    path: '/',
    component: () => import('@/components/Layout/SimpleLayout.vue'),
    children: [
      {
        path: '',
        name: 'SimpleLayout',
        redirect: '/login'
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/login/index.vue'),
        meta: {
          title: '登录',
          requiresAuth: false
        }
      },
      {
        path: 'login/bind-company',
        name: 'BindCompany',
        component: () => import('@/views/login/bind-company.vue'),
        meta: {
          title: '绑定公司名称',
          requiresAuth: true
        }
      },
      // {
      //   path: 'home',
      //   name: 'Home',
      //   component: () => import('@/views/home/index.vue'),
      //   meta: {
      //     title: '首页',
      //     requiresAuth: false
      //   }
      // },
      // 默认404页面 - 未登录状态显示
      {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('@/views/error/notFound.vue'),
        meta: {
          title: '页面不存在',
          requiresAuth: false
        }
      }
    ]
  },

  // 完整布局路由组（有侧边栏）
  {
    path: '/app',
    component: () => import('@/components/Layout/index.vue'),
    children: [
      {
        path: '',
        name: 'AppLayout',
        redirect: '/app/analysis/upload'
      },
      // 招标分析
      {
        path: 'analysis',
        name: 'Analysis',
        children: [
          {
            path: 'quick-start',
            name: 'AnalysisQuickStart',
            component: () => import('@/views/analysis/quick-start/index.vue'),
            meta: {
              title: '快速开始',
              requiresAuth: true
            }
          },
          {
            path: 'upload',
            name: 'AnalysisUpload',
            // component: () => import('@/views/analysis/upload/index.vue'),
            component: () => import('@/views/analysis/list/detail.vue'),
            meta: {
              title: '上传文件',
              requiresAuth: true
            }
          },
          {
            path: 'list',
            name: 'AnalysisList',
            component: () => import('@/views/analysis/list/index.vue'),
            meta: {
              title: '分析列表',
              requiresAuth: true
            }
          },
          {
            path: 'normalization',
            name: 'AnalysisNormalization',
            component: () => import('@/views/analysis/list/normalization.vue'),
            meta: {
              title: '归一化文件',
              requiresAuth: true
            }
          },
          {
            path: 'detail',
            name: 'AnalysisDetail',
            component: () => import('@/views/analysis/list/detail.vue'),
            meta: {
              title: '核对',
              requiresAuth: true
            }
          },
          {
            path: 'generation',
            name: 'BidGenerationDetail',
            component: () => import('@/views/analysis/list/generation.vue'),
            meta: {
              title: '标书详情',
              requiresAuth: true
            }
          }
        ]
      },

      // 投标生成
      // {
      //   path: 'bid-generation',
      //   children: [
      //     {
      //       path: '',
      //       name: 'BidGeneration',
      //       redirect: '/app/bid-generation/list'
      //     },
      //     {
      //       path: 'list',
      //       name: 'BidGenerationList',
      //       component: () => import('@/views/bid-generation/index.vue'),
      //       meta: {
      //         title: '投标生成',
      //         requiresAuth: true
      //       }
      //     },
      //     {
      //       path: 'detail',
      //       name: 'BidGenerationDetail',
      //       component: () => import('@/views/bid-generation/detail.vue'),
      //       meta: {
      //         title: '投标详情',
      //         requiresAuth: true
      //       }
      //     }
      //   ]
      // },

      // 产品及服务库
      {
        path: 'product-service-library',
        children: [
          {
            path: '',
            name: 'ProductServiceLibrary',
            redirect: '/app/product-service-library/products'
          },
          {
            path: 'products',
            name: 'ProductInfo',
            component: () => import('@/views/product-service-library/products/index.vue'),
            meta: {
              title: '产品信息',
              requiresAuth: true
            }
          },
          {
            path: 'services',
            name: 'ServiceInfo',
            component: () => import('@/views/product-service-library/services/index.vue'),
            meta: {
              title: '服务信息',
              requiresAuth: true
            }
          }
        ]
      },

      // 自有库
      {
        path: 'own-library',
        children: [
          {
            path: '',
            name: 'OwnLibrary',
            redirect: '/app/own-library/resource-pool'
          },
          {
            path: 'resource-pool',
            name: 'ResourcePool',
            component: () => import('@/views/own-library/resource-pool/index.vue'),
            meta: {
              title: '资源池',
              requiresAuth: true
            }
          },
          {
            path: 'company-info',
            name: 'CompanyInfo',
            component: () => import('@/views/own-library/company-info/index.vue'),
            meta: {
              title: '公司信息',
              requiresAuth: true
            }
          },
          {
            path: 'qualification',
            name: 'Qualification',
            component: () => import('@/views/own-library/qualification/index.vue'),
            meta: {
              title: '资质管理',
              requiresAuth: true
            }
          },
          {
            path: 'finance',
            name: 'Finance',
            component: () => import('@/views/own-library/finance/index.vue'),
            meta: {
              title: '财务信息',
              requiresAuth: true
            }
          },
          {
            path: 'finance-analysis',
            name: 'FinanceAnalysis',
            component: () => import('@/views/own-library/finance/analysis.vue'),
            meta: {
              title: '财务信息',
              requiresAuth: true
            }
          },
          {
            path: 'performance',
            name: 'Performance',
            component: () => import('@/views/own-library/performance/index.vue'),
            meta: {
              title: '业绩管理',
              requiresAuth: true
            }
          },
          {
            path: 'case',
            name: 'Case',
            component: () => import('@/views/own-library/case/index.vue'),
            meta: {
              title: '案例管理',
              requiresAuth: true
            }
          },
          {
            path: 'staff',
            name: 'Staff',
            component: () => import('@/views/own-library/staff/index.vue'),
            meta: {
              title: '人员管理',
              requiresAuth: true
            }
          },

          {
            path: 'vehicle',
            name: 'Vehicle',
            component: () => import('@/views/own-library/vehicle/index.vue'),
            meta: {
              title: '车辆管理',
              requiresAuth: true
            }
          },
          {
            path: 'tools',
            name: 'Tools',
            component: () => import('@/views/own-library/tools/index.vue'),
            meta: {
              title: '工具器',
              requiresAuth: true
            }
          },
          {
            path: 'spare-parts',
            name: 'SpareParts',
            component: () => import('@/views/own-library/spare-parts/index.vue'),
            meta: {
              title: '备品备件',
              requiresAuth: true
            }
          },
          {
            path: 'history-bids',
            name: 'HistoryBids',
            component: () => import('@/views/own-library/history-bids/index.vue'),
            meta: {
              title: '历史标书',
              requiresAuth: true
            }
          },
          {
            path: 'custom-knowledge',
            name: 'CustomKnowledge',
            component: () => import('@/views/own-library/custom-knowledge/index.vue'),
            meta: {
              title: '自定义知识',
              requiresAuth: true
            }
          }
        ]
      },

      // 用户设置
      {
        path: 'user-settings',
        name: 'UserSettings',
        children: [
          {
            path: 'account',
            name: 'AccountSettings',
            component: () => import('@/views/user-settings/account/index.vue'),
            meta: {
              title: '账户设置',
              requiresAuth: true
            }
          },
          {
            path: 'file-format',
            name: 'FileFormat',
            component: () => import('@/views/user-settings/file-format/index.vue'),
            meta: {
              title: '文件格式',
              requiresAuth: true
            }
          },
          {
            path: 'notifications',
            name: 'Notifications',
            component: () => import('@/views/user-settings/notifications/index.vue'),
            meta: {
              title: '消息通知',
              requiresAuth: true
            }
          },
          {
            path: 'agreement',
            name: 'UserAgreement',
            component: () => import('@/views/user-settings/agreement/index.vue'),
            meta: {
              title: '用户协议',
              requiresAuth: true
            }
          },
          {
            path: 'privacy',
            name: 'PrivacyAgreement',
            component: () => import('@/views/user-settings/privacy/index.vue'),
            meta: {
              title: '隐私协议',
              requiresAuth: true
            }
          }
        ]
      },

      // 带侧边栏的404页面
      {
        path: 'not-found',
        name: 'AppNotFound',
        component: () => import('@/views/error/notFound.vue'),
        meta: {
          title: '页面不存在',
          requiresAuth: true
        }
      }
    ]
  },
]

export default routes